<template>
  <div class="container-fluid container-with-vertical-nav full-height container-table">
    <div v-if="$apollo.loading">
      <div style="margin-top: 10%;" class="text-center">
        <div class="spinner" />
        <strong>กำลังโหลด..</strong>
      </div>
    </div>
    <div v-else>
      <data-table :data="osdaUsers" :columns="columns" :filters="filters" name="บัญชี" create-link="/settings/groups/create">
        <div slot="toolbar-button">
          <button class="btn btn-primary" data-toggle="modal" data-target="#addOsdaUserDialog">เพิ่มบัญชีเจ้าหน้าที่</button>
        </div>

        <template slot="thead">
          <tr>
            <th width="30">#</th>
            <th>ชื่อบัญชี</th>
            <th>การกระทำ</th>
          </tr>
        </template>
      </data-table>

      <div id="addOsdaUserDialog" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                <span class="pficon pficon-close" />
              </button>
              <h4 class="modal-title">เพิ่มบัญชีเจ้าหน้าที่องค์การนักศึกษา</h4>
            </div>
            <div class="modal-body">
              <div class="alert alert-info">
                <span class="pficon pficon-info" />
                กรอกชื่อผู้ใช้งาน (Username) ของบัญชีที่ต้องการเพิ่มให้เป็นเจ้าหน้าที่องค์การนักศึกษา (บัญชีนักศึกษาไม่สามารถเพิ่มได้)
              </div>
              <div class="form-horizontal">
                <div class="form-group">
                  <label class="col-sm-3 control-label">ชื่อผู้ใช้</label>
                  <div class="col-sm-6">
                    <input ref="input" v-model="addUser.username" type="text" class="form-control">
                  </div>
                  <div class="col-sm-2">
                    <button class="btn btn-primary btn-block" type="button" @click.prevent="lookupUser">ค้นหา</button>
                  </div>
                </div>
                <div v-if="addUser.lookupResult !== null" class="course-search-result">
                  <div v-if="addUser.lookupResult" class="well">
                    <dl class="dl-horizontal no-margin">
                      <dt>ชื่อผู้ใช้</dt>
                      <dd>{{ addUser.lookupResult.uid }}</dd>
                      <dt>ชื่อ</dt>
                      <dd>{{ addUser.lookupResult.firstName }}</dd>
                      <dt>นามสกุล</dt>
                      <dd class="no-margin">{{ addUser.lookupResult.lastName }}</dd>
                    </dl>
                  </div>
                  <div v-else class="alert alert-danger">
                    <span class="pficon pficon-error-circle-o" />
                    ไม่พบรายวิชา ตรวจสอบรหัสวิชาอีกครั้ง
                  </div>
                </div>
              </div>
              <hr>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" @click="clearForm">ยกเลิก</button>
              <button type="button" class="btn btn-primary" :disabled="addUser.lookupResult === null || addUser.lookupResult === false" @click="addOsdaUser">เพิ่มผู้ประสานงาน</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import DataTable from '../../../components/shared/DataTable'

export default {
  components: {
    DataTable
  },
  apollo: {
    osdaUsers: gql`{
      osdaUsers {
        _id
        firstName
        lastName
      }
    }`
  },
  data () {
    return {
      addUser: {
        username: '',
        lookupResult: null
      },
      filters: [
        { key: 'name', text: 'ชื่อบัญชี' }
      ],
      columns: [
        {
          data: null,
          render: (data, type, row, meta) => {
            return meta.row + 1
          }
        },
        {
          data: null,
          render: (data, type, row, meta) => {
            return row.firstName + ' ' + row.lastName
          }
        },
        {
          data: null,
          className: 'table-view-pf-actions text-center text-nowrap',
          render: function (data, type, row, meta) {
            // Inline action button renderer
            return `<div class="table-view-pf-btn"><a href="/settings/osda-users/${row._id}" class="btn btn-default">ดูข้อมูล</a></div>`
          }
        }
      ]
    }
  },
  methods: {
    clearForm () {
      this.addUser.lookupResult = null
      this.addUser.username = ''
    },
    async lookupUser () {
      this.addUser.lookupResult = null

      let user = await this.$apollo.query({
        query: gql`query userLookup($username: String!) {
          userLookup(role: "per", username: $username) {
            uid
            firstName
            lastName
          }
        }`,
        variables: {
          username: this.addUser.username
        }
      })

      if (user.data.userLookup) {
        this.addUser.lookupResult = user.data.userLookup
      } else {
        this.addUser.lookupResult = false
      }
    },
    async addOsdaUser () {
      await this.$apollo.mutate({
        mutation: gql`mutation ($username: String!) {
          addOsdaUser(username: $username) {
            _id
          }
        }`,
        variables: {
          username: this.addUser.username
        }
      })

      this.$apollo.queries.osdaUsers.refetch()

      // this.$router.go()
    }
  }
}
</script>
<style lang="sass" scoped>
//
</style>



// WEBPACK FOOTER //
// src/js/views/settings/osda_user/Index.vue